// extracted by mini-css-extract-plugin
export default {"contentRight":"styles_contentRight__+-Jys"};